import {
    Box, Button, Grid, Icon,
    Menu, Stack, Typography
} from '@mui/material'

import { Fragment, useRef, useState } from 'react'
import { useNavigate } from 'react-router-dom'

import  {createId } from '@services/utils'

export const Universe = (props) => {
    const navigate = useNavigate()

    const [anchorEl, setAnchorEl] = useState(null)
    const open = Boolean(anchorEl)

    const itemStyle = useRef({
        padding: '16px',
        paddingTop: '8px',
        paddingBottom: '8px',
        maxWidth: '270px'
    })

    const handleOpenMenu = (event) => {
        setAnchorEl(event.currentTarget)
    }

    const handleClose = () => {
        setAnchorEl(null)
    }

    const changeUniverse = (path) => () => {
        handleClose()
        navigate(path)
    }

    return (
        <Fragment>
            <Button className={'nunito'} variant={'universe'} endIcon={<Icon>keyboard_arrow_down</Icon>} onClick={handleOpenMenu}>
                {props.uname ?? '-'}
            </Button>
            <Menu
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                PaperProps={{sx:{mt: '24px', borderRadius: '8px'}}}
            >
                <Box sx={itemStyle.current}>
                    <Grid container spacing={2} textAlign={'center'} alignItems={'center'}>
                        {props.products && props.products.length > 0 && props.products.map(item => {
                            const id = createId()
                            return (
                                <Grid key={id}>
                                    <Button variant={'tertiary'} sx={{height: 'auto', borderRadius: '8px'}} onClick={changeUniverse(item.path)}>
                                        <Stack alignItems={'center'}>
                                            <Icon>{item.icon}</Icon>
                                            <Typography variant={'h5'}>{item.label}</Typography>
                                        </Stack>
                                    </Button>
                                </Grid>
                            )
                        })}
                    </Grid>
                </Box>
            </Menu>
        </Fragment>
    )
}

export default Universe